import { css } from '@emotion/react';
import { transition } from '../../utils/styleUtils';
export const klarnaCategoryIconStyles = css({
    stroke: 'none',
    transform: 'scale(0.9)',
    transition: transition({
        attributes: [
            'transform'
        ],
        easing: 'wobbly'
    }),
    [`a:hover &, a:focus &, 
      button:hover &, button:focus &`]: {
        transform: 'scale(1)'
    }
});
